import waitUntil from 'async-wait-until';
import { addClass, removeClass, removeNode, closest } from '@utils/domUtils';

export default class JobCreateSummary {
  static selectorString() {
    return '.JobCreateSummary';
  }

  async render(node, props) {
    this.form = closest(node, 'form');
    this.jobCreateWizard = closest(node, '.JobCreateWizard');
    this.jobProfileSelector = this.jobCreateWizard.querySelector('.JobProfileSelector');
    this.jobAdEditor = this.jobCreateWizard.querySelector('.JobAdEditor');
    this.jobCreateGeneral = this.jobCreateWizard.querySelector('.JobCreateGeneral');
    this.publishChannelSelectors = [
      ...this.jobCreateWizard.querySelectorAll('.PublishChannelSelector'),
    ];

    this.jobTitleField = node.querySelector('[data-prop="jobTitle"]');
    this.industryField = node.querySelector('[data-prop="industry"]');
    this.subIndustryField = node.querySelector('[data-prop="subIndustry"]');
    this.jobProfileField = node.querySelector('[data-prop="jobProfile"]');
    this.contactPersonActive = node.querySelector('.contact-person-active');
    this.contactPersonInactive = node.querySelector('.contact-person-inactive');
    this.contactTitleField = node.querySelector('[data-prop="contactTitle"]');
    this.addressField = node.querySelector('[data-prop="address"]');
    this.workTimeField = node.querySelector('[data-prop="workTime"]');
    this.employmentTypeField = node.querySelector('[data-prop="employmentType"]');
    this.targetPublishChannelsField = node.querySelector('[data-prop="targetPublishChannels"]');
    this.uploadedDocumentsField = node.querySelector('[data-prop="uploadedDocuments"]');
    this.targetPublishChannelsUnselected = node.querySelector('.publish-channels-unselected');
    this.uploadedDocumentsEmpty = node.querySelector('.uploaded-documents-empty');

    this.publishChannelEntryTemplate = node.querySelector('.publish-channel-entry-template');
    removeNode(this.publishChannelEntryTemplate);
    removeClass(this.publishChannelEntryTemplate, 'publish-channel-entry-template');

    this.uploadedDocumentTemplate = node.querySelector('.uploaded-document-template');
    removeNode(this.uploadedDocumentTemplate);
    removeClass(this.uploadedDocumentTemplate, 'uploaded-document-template');

    await waitUntil(() => this.jobProfileSelector.component);
    await waitUntil(() => this.jobAdEditor.component);
    await waitUntil(() => this.jobCreateGeneral.component);
    await waitUntil(
      () =>
        this.publishChannelSelectors.filter(node => !!node.component).length ===
        this.publishChannelSelectors.length,
    );

    this.jobCreateWizard.addEventListener('stepChanged', this.updateSummary.bind(this));

    [...this.jobAdEditor.querySelectorAll('.FileUpload')].forEach(fileInput => {
      fileInput.addEventListener('fileUploadSuccess', this.updateSummary.bind(this));
      fileInput.addEventListener('fileRemoved', this.updateSummary.bind(this));
    });

    this.updateSummary();
  }

  updateSummary() {
    const jobTitle = this.jobCreateGeneral.component.getJobTitle();
    const contactTitle = this.jobAdEditor.component.getContactTitle();
    const industryName = this.jobProfileSelector.component.getIndustryName();
    const subIndustryName = this.jobProfileSelector.component.getSubIndustryName();
    const jobProfileName = this.jobProfileSelector.component.getJobProfileName();
    const contactPersonVisible = this.jobAdEditor.component.isRenderingContactPerson();
    const address = this.jobCreateGeneral.component.getSelectedAddress();
    const workTimes = this.jobCreateGeneral.component.getWorkTimes();
    const employmentTypes = this.jobCreateGeneral.component.getEmploymentTypes();
    const targetPublishChannels = this.publishChannelSelectors.reduce(
      (result, node) => [...result, ...node.component.getSelectedChannels()],
      [],
    );
    const uploadedFiles = this.jobAdEditor.component.getUploadedFiles();

    this.jobTitleField.innerHTML = jobTitle;
    this.industryField.innerHTML = industryName;
    this.subIndustryField.innerHTML = subIndustryName;
    this.jobProfileField.innerHTML = jobProfileName;
    this.contactTitleField.innerHTML = contactTitle;

    if (contactPersonVisible) {
      removeClass(this.contactTitleField, 'hide');
      removeClass(this.contactPersonActive, 'hide');
      addClass(this.contactPersonInactive, 'hide');
    } else {
      addClass(this.contactTitleField, 'hide');
      addClass(this.contactPersonActive, 'hide');
      removeClass(this.contactPersonInactive, 'hide');
    }

    this.addressField.innerHTML = address;
    this.workTimeField.innerHTML = workTimes.join(' | ');
    this.employmentTypeField.innerHTML = employmentTypes.join(' | ');

    this.targetPublishChannelsField.innerHTML = '';
    targetPublishChannels.forEach(channel => {
      const publishChannelEntry = this.publishChannelEntryTemplate.cloneNode(true);
      publishChannelEntry.querySelector('[data-prop="publishChannelTitle"]').innerHTML =
        channel.label;
      publishChannelEntry.querySelector('[data-prop="publishChannelRuntime"]').innerHTML =
        channel.runtime;
      publishChannelEntry.querySelector('[data-prop="publishChannelPrice"]').innerHTML =
        channel.price;
      this.targetPublishChannelsField.appendChild(publishChannelEntry);
    });

    if (targetPublishChannels.length === 0) {
      removeClass(this.targetPublishChannelsUnselected, 'hide');
    } else {
      addClass(this.targetPublishChannelsUnselected, 'hide');
    }

    this.uploadedDocumentsField.innerHTML = '';
    uploadedFiles.forEach(file => {
      const uploadedDocument = this.uploadedDocumentTemplate.cloneNode(true);
      uploadedDocument.querySelector('[data-prop="filename"]').innerHTML = file.name;
      this.uploadedDocumentsField.appendChild(uploadedDocument);
    });

    if (uploadedFiles.length === 0) {
      removeClass(this.uploadedDocumentsEmpty, 'hide');
    } else {
      addClass(this.uploadedDocumentsEmpty, 'hide');
    }
  }
}
